import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { IconActionChevronDownSmall16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './PromoSearchTypeWrapper.css';

interface IPromoSearchTypeWrapperProps {
  onMoreButtonClick: () => void;
  hasMore: boolean;
  dataTestId?: string;
}

export const PromoSearchTypeWrapper = ({
  children,
  onMoreButtonClick,
  hasMore,
  dataTestId,
}: React.PropsWithChildren<IPromoSearchTypeWrapperProps>) => {
  return (
    <div className={styles['container']}>
      {children}
      {hasMore && (
        <Button
          size="M"
          theme="fill_white_primary"
          afterIcon={<IconActionChevronDownSmall16 color="current_color" />}
          onClick={onMoreButtonClick}
          data-testid={dataTestId}
        >
          Смотреть все
        </Button>
      )}
    </div>
  );
};
